module.exports = __webpack_public_path__ + "img/symbol_5.bd1dc14a.png";